import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useEffect, useState } from 'react';
import { Collapse } from '@crehana/compass.ui';
// biome-ignore lint/style/noRestrictedImports: legacy import, will be migrated
import { Clamp } from '@crehana/ui';
import { clsx } from 'clsx';
import { AuthUserRoleEnum } from "../../../../generated/graphql/types";
import { handleNavigation } from "../../../../shared/utils";
import { useSidebar } from "../../sidebar-context";
import { CollapsedLink } from "./collapsed-link";
import { MenuDesktopLink } from "./menu-desktop-link";
import { SubMenuDesktopLink } from "./sub-menu-desktop-link";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
export var LinkWithDropdown = function LinkWithDropdown(_ref) {
  var menuLink = _ref.menuLink,
    _onClickItem = _ref.onClickItem,
    currentActive = _ref.currentActive,
    sidebarType = _ref.sidebarType,
    centralizedId = _ref.centralizedId;
  var _useSidebar = useSidebar(),
    isDark = _useSidebar.isDark,
    sidebarCollapsed = _useSidebar.sidebarCollapsed;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isHovered = _useState2[0],
    setIsHovered = _useState2[1];
  var _menuLink$children = menuLink.children,
    children = _menuLink$children === void 0 ? [] : _menuLink$children,
    _menuLink$defaultOpen = menuLink.defaultOpen,
    defaultOpen = _menuLink$defaultOpen === void 0 ? false : _menuLink$defaultOpen;
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isSubmenuExpanded = _useState4[0],
    setIsSubmenuExpanded = _useState4[1];
  var userRole = sidebarType === 'admin' ? AuthUserRoleEnum.AuthRoleAdmin : AuthUserRoleEnum.AuthRoleUser;

  // const { generateUrl } = useGenerateTokenUrl(
  //   userRole,
  //   centralizedId,
  //   isProduction,
  // );

  useEffect(function () {
    // biome-ignore lint/style/useBlockStatements: single-line early return
    if (currentActive && children.find(function (link) {
      return link.code === currentActive.code;
    })) setIsSubmenuExpanded(true);
  }, [currentActive, children]);
  var Icon = menuLink.activeIcon || menuLink.icon;
  useEffect(function () {
    if (defaultOpen) {
      var timeout = setTimeout(function () {
        setIsSubmenuExpanded(true);
      }, 120);
      return function () {
        return clearTimeout(timeout);
      };
    }
  }, [defaultOpen]);
  if (sidebarCollapsed) {
    return /*#__PURE__*/_jsx(CollapsedLink, {
      isDark: isDark,
      menuLink: menuLink,
      isOpened: isSubmenuExpanded,
      onClickOutside: function onClickOutside() {
        setIsSubmenuExpanded(false);
      },
      isHovered: isHovered,
      onMouseEnter: function onMouseEnter() {
        return setIsHovered(true);
      },
      onMouseLeave: function onMouseLeave() {
        return setIsHovered(false);
      },
      onClickItem: _onClickItem,
      toggleDropdown: function toggleDropdown() {
        setIsSubmenuExpanded(function (prev) {
          return !prev;
        });
      },
      currentActive: currentActive
    });
  }
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs(MenuDesktopLink, {
      isSelected: isSubmenuExpanded,
      toggleDropdown: function toggleDropdown() {
        setIsSubmenuExpanded(function (prev) {
          return !prev;
        });
      },
      onMouseEnter: function onMouseEnter() {
        return setIsHovered(true);
      },
      onMouseLeave: function onMouseLeave() {
        return setIsHovered(false);
      },
      isHovered: isHovered,
      children: [Icon && /*#__PURE__*/_jsx(Icon, {
        size: 16,
        className: clsx('tw-fill-current tw-w-2.4 tw-min-w-2.4 tw-max-h-2.4', isSubmenuExpanded || isHovered ? ' tw-text-primary-light-500 dark:tw-text-secondary-dark-400' : 'tw-text-neutral-light-700 dark:tw-text-neutral-dark-300'),
        ignoreColor: true
      }), /*#__PURE__*/_jsx(Clamp, {
        clamp: 1,
        title: menuLink.label.length > 20 ? menuLink.label : undefined,
        className: clsx('tw-ml-0.8 tw-break-all tw-font-subtitle5 ', isSubmenuExpanded && !isHovered && 'tw-text-neutral-dark-700', isHovered ? 'tw-text-primary-light-500' : 'tw-text-neutral-light-700 dark:tw-text-neutral-dark-300'),
        children: menuLink.label
      })]
    }, menuLink.code), /*#__PURE__*/_jsx(Collapse, {
      open: isSubmenuExpanded,
      children: /*#__PURE__*/_jsx("ul", {
        className: "tw-block tw-w-full tw-pt-0.4",
        children: children.map(function (child) {
          return /*#__PURE__*/_jsx(SubMenuDesktopLink, {
            code: child.code,
            label: child.label,
            url: child.url || '',
            isDark: isDark,
            isSelectedURL: Boolean(currentActive && currentActive.code === child.code),
            onClickItem: function onClickItem() {
              handleNavigation({
                url: child.url || '',
                centralizedId: centralizedId || '',
                userRole: userRole,
                // eslint-disable-next-line @typescript-eslint/no-empty-function
                // biome-ignore lint/suspicious/noEmptyBlockStatements: intentional empty block
                onClickItem: _onClickItem || function () {},
                openInNewTab: child.openInNewTab || false
              });
            },
            isLocked: child.isLocked
          }, child.code);
        })
      })
    })]
  });
};